import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
import { AnagraficaForm } from '../../../form/anagrafica-form';
import { AnagraficaResponse } from '../../../models/dto/anagrafica-response';
import { Parte } from '../../../models/parte';
import { FormValidationService } from '../../../services/form-validation.service';
import { ParteAdapter } from './parte-adapter';

declare var closeModal: any;

@Component({
  selector: 'div [parte-anagrafica-form-add]',
  templateUrl: '../../../form/anagrafica-form.html',
})

export class ParteAnagraficaAddComponent extends AnagraficaForm implements OnInit {
  urlAggiungiInAnagrafica: string;
  tipoPratica: string;
  @Output() onReturn: EventEmitter<Parte> = new EventEmitter<Parte>();
  @Input() labelButton: string = 'Inserisci e associa';
  @Input() isControparti: boolean = false;
  subscriptionCreate: Subscription;

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService , @Inject(ModalNotifyService) private modalNotifyService) {
        super(operationService, campiForm, helpers, formValidationService);
  }
  ngOnInit() {
    this.isInserimento(true);
  }

  getAdapter(): Parte {
    return new ParteAdapter(new Parte()).parte;
  }

   private aggiungiAnagrafica(request: Parte, response: boolean) {
    if (response) {
      	this.operationService.addAnagraficaElement(request).subscribe(response => this.parteCreata(<AnagraficaResponse> response));
    }
    if (this.subscriptionCreate) {
      this.subscriptionCreate.unsubscribe();
    }
  }

  getRequest(request: Parte) {
	if(!request.codiceFiscale && request.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA){
		this.subscriptionCreate = this.modalNotifyService.notifyConfirmObservable.subscribe(result =>this.aggiungiAnagrafica(request,result));
		this.modalNotifyService.notifyCustom('ATTENZIONE: La mancata indicazione del Codice Fiscale potrebbe causare problemi di identificazione univoca dell\'anagrafica. Vuoi proseguire? ');
	}else{
		this.operationService.addAnagraficaElement(request).subscribe(response => this.parteCreata(<AnagraficaResponse> response));
	}
  }

  parteCreata(response: AnagraficaResponse) {
    this.onReturn.emit(response.anagrafiche[0] as Parte);
  }
  inizializza(urlAggiungiInAnagrafica: string, tipoPratica, idTipoFascicolo = null, isControparti: boolean = false) {
    this.tipoPratica = tipoPratica;
    this.urlAggiungiInAnagrafica = urlAggiungiInAnagrafica;
    this.idTipoFascicolo = idTipoFascicolo;
    this.isControparti = isControparti;
    this.populateSelect();
    this.createForm();
  }

  hasConvenzione(): boolean {
    return false;
  }

  hasTariffa(): boolean {
    return false;
  }

  hasAmbitiCompetenza(): boolean {
    return false;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

   ngOnDestroy(): void {
    if (this.subscriptionCreate) {
      this.subscriptionCreate.unsubscribe();
    }
  }
}
